module.exports = "{% if title is not empty %}\n<h2>{{title|e}}</h2>\n{% endif %}\n<nav>\n</nav>\n";
